module.exports = __webpack_public_path__ + "static/banner--2-d175a1e823f3e926f9a755e5c5cbb736.jpg";